import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import LaunchRoundedIcon from '@mui/icons-material/LaunchRounded';
import Button from '@mui/material/Button';
import { useCallback } from 'react';
import { DiscordIcon } from '../icons/discordIcon';
const DISCORD_SERVER_URL = 'https://discord.gg/g588DFqAYY';
export const DiscordButton = ({ size = 'small', label, variant = 'contained' }) => {
    const onClickDiscord = useCallback(() => {
        window.open(DISCORD_SERVER_URL, '_blank');
    }, []);
    return (_jsx(Button, { onClick: onClickDiscord, variant: variant, size: size, startIcon: _jsx(DiscordIcon, {}), endIcon: _jsx(LaunchRoundedIcon, { style: { opacity: 0.4 } }), children: label }));
};
